module.exports = __webpack_public_path__ + "img/clear-icon.b840e171.svg";